import {useGetAndSet} from "./useGetAndSet";
import {createSetUtilsDataAction} from "../actions/dataActions";


export function useUtilData(params, dataFresh){
    return useGetAndSet("util", params, createSetUtilsDataAction, dataFresh);
}